import "./Home.css";
import mapImg from "../assets/WestUPMaps.png"
import { Link } from "react-router-dom";
import Footer from "../Components/footer/footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Carousel from "../Components/Carousel/carousel";

export default function Home() {
  return (
    <div>
      <Carousel/>
      {/* HERO SECTION */}
      <section className="hero">
        <h1>Hum Paschimanchal</h1>
        <p>West UP ke youth ko connect karne ka ek platform</p>

        <Link to="/join">
          <button className="hero-btn">Join Movement</button>
        </Link>
      </section>

      {/* ABOUT SHORT */}
      <section className="about-home">
        <h2>About Initiative</h2>
        <p>
          Hum Paschimanchal ek initiative hai jo youth ko ek platform par jodne,
          awareness create karne aur development ko accelerate karne ka kaam karta hai.
        </p>
      </section>

      {/* MISSION CARDS */}
      <section className="features">
        <div className="card">
          <h3>Awareness</h3>
          <p>Youth ko jagruk banana</p>
        </div>

        <div className="card">
          <h3>Employment</h3>
          <p>Rozgar aur growth opportunities</p>
        </div>

        <div className="card">
          <h3>Unity</h3>
          <p>Sabko ek platform par lana</p>
        </div>

        <div className="card">
          <h3>Development</h3>
          <p>Region ka overall development</p>
        </div>
      </section>

      {/* MAP SECTION */}
      <section className="map-section">
        <h2>Paschimanchal Region</h2>
        <p>West UP ke districts ka ek overview</p>

      <img src={mapImg} alt="West UP Map" className="map-img" />
      </section>

      {/* CTA */}
      <section className="cta">
        <h2>Be a Part of Change</h2>
        <p>Aaj hi jud kar Paschimanchal ko aage badhayein</p>

        <Link to="/join">
          <button className="cta-btn">Get Involved</button>
        </Link>
      </section>
      <Footer />
    </div>
  );
}